import '.fr{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fs{padding-left:1.5rem;}.ssr-plugin'
import '.ft{margin:1rem 0;}.ssr-plugin'
import '.fu{color:var(--gray-700);}.ssr-plugin'
import '.fv{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fr fs ft fu fv"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
